import React, {useEffect} from "react";
import {BrowserRouter as Router, Navigate, Route, Routes, useNavigate, useParams,} from "react-router-dom";
import {FunnelProvider, useFunnel} from "./context/FunnelContext";
import {MainLayout} from "./components/MainLayout";
import {StepRenderer} from "./components/StepRenderer";
import {getStepById, getStepId} from "./utils/stepsConfig";
import {SuccessPayment} from "./components/layout/paywall/SuccessPayment";
import {initGA} from "./utils/analytics";
import {initFBPixel} from "./utils/facebookPixel";

function FunnelStep() {
    const {state} = useFunnel();
    const navigate = useNavigate();

    // Update URL when step changes
    useEffect(() => {
        const stepId = getStepId(state.currentStep);
        if (stepId) {
            navigate(`/step/${stepId}`);
        }
    }, [state.currentStep, navigate]);

    return (
        <div className="animate-fadeIn">
            <StepRenderer stepId={state.currentStep}/>
        </div>
    );
}

function FunnelContainer() {
    const {stepId} = useParams();
    const {dispatch} = useFunnel();

    useEffect(() => {
        // Convert URL stepId to internal step index/id
        const stepIndex = getStepById(stepId);
        if (stepIndex !== -1) {
            dispatch({
                type: "SET_STEP",
                payload: stepIndex,
            });
        }
    }, [stepId, dispatch]);

    return (
        <MainLayout>
            <div className="transition-all duration-300 ease-in-out">
                <FunnelStep/>
            </div>
        </MainLayout>
    );
}

function App() {
    useEffect(() => {
        // Initialize GA with your measurement ID
        initGA("G-4KVREC157R");
        initFBPixel("1173656900819866");
    }, []);

    return (
        <Router>
            <FunnelProvider>
                <div id="app" className="h-full w-full">
                    <Routes>
                        <Route path="/step/:stepId" element={<FunnelContainer/>}/>
                        <Route path="/payment/success" element={<SuccessPayment/>}/>
                        <Route path="/" element={<Navigate to="/step/welcome" replace/>}/>
                    </Routes>
                </div>
            </FunnelProvider>
        </Router>
    );
}

export default App;
